import React from 'react';
import styled from 'styled-components';
import {Row} from 'react-table';
import {useClientPreleadCustomizeItemsQuery, Prelead} from 'api';

interface Props {
  row: Row<Prelead>;
  value: any;
}

const CustomizeItemSelectCell = ({row, value}: Props) => {
  const prelead: Prelead = row.original;
  const clientPreleadCustomizeItemId = value;

  const {data: {clientPreleadCustomizeItems = []} = {}} =
    useClientPreleadCustomizeItemsQuery();

  const customizeItem = React.useMemo(
    () =>
      prelead.customizeItemSelects.find(
        (item) =>
          item.clientPreleadCustomizeItemId === clientPreleadCustomizeItemId,
      ),
    [prelead, clientPreleadCustomizeItemId],
  );

  const clientPreleadCustomizeItem = React.useMemo(
    () =>
      clientPreleadCustomizeItems.find(
        (item) => item.id === clientPreleadCustomizeItemId,
      ),
    [clientPreleadCustomizeItems, clientPreleadCustomizeItemId],
  );

  const tags = React.useMemo(
    () =>
      customizeItem && clientPreleadCustomizeItem
        ? clientPreleadCustomizeItem.selectOptions.filter((option) =>
            customizeItem?.clientPreleadCustomizeItemSelectOptionIds.includes(
              option.id,
            ),
          )
        : [],
    [customizeItem, clientPreleadCustomizeItem],
  );

  return (
    <Container>
      {tags.map((tag) => (
        <Tag key={tag.id}>{tag.label}</Tag>
      ))}
    </Container>
  );
};

export default CustomizeItemSelectCell;

const Container = styled.div`
  display: flex;
  gap: 3px;
`;

const Tag = styled.span`
  padding: 1px 8px;
  background: #f5f5f5;
  border-radius: 2px;
  font-size: 9px;
  letter-spacing: 0.15px;
`;
